import React from "react";
import { style } from "../style";


export default function CategoryHeading(props: { category: string })
{
    return (
        <div className="flex flex-row">
            <div className="w-6 h-18 bg-black mr-1 align-middle"></div>
            <div>
                <div className="uppercase text-sm mb-0">category</div>
                <h2 className="font-navine uppercase tracking-widest font-semibold text-5xl">{props.category}</h2>
            </div>
        </div >
    )
}